import PropTypes from "prop-types";

import './SidebarActionButton.scss';
const SidebarActionButton = ({
  icon: Icon,
  label,
  onClick,
  disabled = false,
}) => (
  <button className="sidebar-button" onClick={onClick} disabled={disabled}>
    <Icon className="sidebar-button__icon" />
    {label}
  </button>
);

SidebarActionButton.propTypes = {
  icon: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
export default SidebarActionButton;
